import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Stats from "@/components/Stats";
import Pricing from "@/components/Pricing";
import Brands from "@/components/Brands";
import Expertise from "@/components/Expertise";
import Spares from "@/components/Spares";
import Warranty from "@/components/Warranty";
import CareFlow from "@/components/CareFlow";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import StickyBar from "@/components/StickyBar";
import Booking from "@/components/Booking";

export default function App() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const openBooking = useCallback(() => setBookingOpen(true), []);
  const closeBooking = useCallback(() => setBookingOpen(false), []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-ink font-body text-ivory antialiased">
      <Header onBook={openBooking} />
      <main>
        <Hero onBook={openBooking} />
        <Marquee />
        <Stats />
        <Pricing />
        <Brands />
        <Expertise />
        <Spares />
        <Warranty />
        <CareFlow />
        <Contact onBook={openBooking} />
      </main>
      <Footer />
      <StickyBar onBook={openBooking} />
      <Booking open={bookingOpen} onClose={closeBooking} />
    </div>
  );
}
